import { TaxIncomeDocumentShareholdersType } from 'modules/partners/components/PartnerAside/utils/generateTaxIncomeDocument';

type Props = {
  hasSEPAOption: boolean;
  hasTaxTemplate: boolean;
  hasDividendTemplate: boolean;
  hasDividendFiscalDocument: boolean;
  hasDividendRequestDocument: boolean;
  // eslint-disable-next-line no-undef
  handleGenerateBankDocument: VoidFunction;
  // eslint-disable-next-line no-undef
  handleGenerateTaxDeclaration: (
    shareholdersType: TaxIncomeDocumentShareholdersType // eslint-disable-line no-unused-vars
  ) => Promise<void>;
  // eslint-disable-next-line no-undef
  handleOpenDividendModal: VoidFunction;
  // eslint-disable-next-line no-undef
  handleGenerateTax193: (
    shareholdersType: TaxIncomeDocumentShareholdersType // eslint-disable-line no-unused-vars
  ) => Promise<void>;
  handleDownloadDividendFiscalDocument: () => Promise<void>;
  handleDownloadDividendRequestDocument: () => Promise<void>;
};

export default [
  {
    id: 'download-SEPA',
    icon: 'ni-file-text',
    rawText: 'SEPADocument',
    action: ({ handleGenerateBankDocument }: Props) =>
      handleGenerateBankDocument(),
    dropdown: true,
    hide: ({ hasSEPAOption }: Props) => !hasSEPAOption,
  },
  {
    id: 'download-tax-declaration',
    icon: 'ni-file-pdf',
    rawText: 'TaxDeclaration',
    action: ({ handleGenerateTaxDeclaration }: Props) =>
      handleGenerateTaxDeclaration(TaxIncomeDocumentShareholdersType.ALL),
    dropdown: true,
    hide: ({ hasTaxTemplate }: Props) => !hasTaxTemplate,
  },
  {
    id: 'download-tax-declaration-residents',
    icon: 'ni-file-pdf',
    rawText: 'TaxDeclarationResidents',
    action: ({ handleGenerateTax193 }: Props) =>
      handleGenerateTax193(TaxIncomeDocumentShareholdersType.RESIDENTS),
    dropdown: true,
    hide: ({ hasTaxTemplate }: Props) => !hasTaxTemplate,
  },
  {
    id: 'download-tax-declaration-non-residents',
    icon: 'ni-file-pdf',
    rawText: 'TaxDeclarationNonResidents',
    action: ({ handleGenerateTaxDeclaration }: Props) =>
      handleGenerateTaxDeclaration(
        TaxIncomeDocumentShareholdersType.NON_RESIDENTS
      ),
    dropdown: true,
    hide: ({ hasTaxTemplate }: Props) => !hasTaxTemplate,
  },
  {
    id: 'download-dividend',
    icon: 'ni-file-pdf',
    rawText: 'DividendsDocument',
    action: ({ handleOpenDividendModal }: Props) => handleOpenDividendModal(),
    hide: ({ hasDividendTemplate }: Props) => !hasDividendTemplate,
    dropdown: true,
  },

  {
    id: 'download-dividend-fiscal-document',
    icon: 'ni-file-xls',
    rawText: 'DownloadDividendFiscalDocument',
    action: ({ handleDownloadDividendFiscalDocument }: Props) =>
      handleDownloadDividendFiscalDocument(),
    hide: ({ hasDividendFiscalDocument }: Props) => !hasDividendFiscalDocument,
    dropdown: true,
  },

  {
    id: 'download-dividend-request-document',
    icon: 'ni-file-xls',
    rawText: 'DownloadDividendRequestDocument',
    action: ({ handleDownloadDividendRequestDocument }: Props) =>
      handleDownloadDividendRequestDocument(),
    hide: ({ hasDividendRequestDocument }: Props) =>
      !hasDividendRequestDocument,
    dropdown: true,
  },
];
